import React, { useState, useEffect, useCallback, useRef } from 'react';
import './Gallery.css';

export default function Gallery({ t }) {
  const [photos, setPhotos]     = useState([]);
  const [lightbox, setLightbox] = useState(null);
  const stripRef = useRef(null);
  const wrapRef  = useRef(null);

  useEffect(() => {
    fetch('/api/photos')
      .then(r => r.json())
      .then(setPhotos)
      .catch(() => setPhotos([]));
  }, []);

  const prev = useCallback(() => setLightbox(i => (i - 1 + photos.length) % photos.length), [photos.length]);
  const next = useCallback(() => setLightbox(i => (i + 1) % photos.length), [photos.length]);

  useEffect(() => {
    if (lightbox === null) return;
    const onKey = (e) => {
      if (e.key === 'ArrowLeft')  prev();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'Escape')     setLightbox(null);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox, prev, next]);

  useEffect(() => {
    if (lightbox === null || !stripRef.current || !wrapRef.current) return;
    const active = stripRef.current.children[lightbox];
    if (active) {
      wrapRef.current.scrollLeft = active.offsetLeft - wrapRef.current.clientWidth / 2 + active.offsetWidth / 2;
    }
    stripRef.current.querySelectorAll('.lb-thumb').forEach((thumb, i) => {
      thumb.classList.toggle('lb-active', i === lightbox);
    });
  }, [lightbox]);

  return (
    <section id="gallery" className="gallery">
      <h2 className="section-title">{t.title}</h2>
      <p className="section-subtitle">{t.subtitle}</p>

      <div className="gallery-grid">
        {photos.map((src, i) => (
          <button
            key={src}
            className="gallery-item"
            onClick={() => setLightbox(i)}
            style={{ '--delay': `${i * 0.07}s` }}
          >
            <img src={`/photos/${src}`} alt={`Master Dante ${i + 1}`} loading="lazy" />
            <div className="gallery-item-overlay">
              <span>✦</span>
            </div>
          </button>
        ))}
      </div>

      {lightbox !== null && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lb-close" onClick={() => setLightbox(null)}>✕</button>
          <button className="lb-arrow lb-prev" onClick={e => { e.stopPropagation(); prev(); }}>‹</button>
          <img
            src={`/photos/${photos[lightbox]}`}
            alt=""
            onClick={e => e.stopPropagation()}
          />
          <button className="lb-arrow lb-next" onClick={e => { e.stopPropagation(); next(); }}>›</button>
          <p className="lb-counter">{lightbox + 1} / {photos.length}</p>
          <div className="lb-filmstrip-wrap" ref={wrapRef}>
            <div className="lb-filmstrip" ref={stripRef}>
              {photos.map((src, i) => (
                <img
                  key={src}
                  className={`lb-thumb${i === lightbox ? ' lb-active' : ''}`}
                  src={`/photos/${src}`}
                  alt=""
                  onClick={e => { e.stopPropagation(); setLightbox(i); }}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
